module.exports = __webpack_public_path__ + "img/shiguanai.b50139bf.png";